export interface SelectOption {
    name: string;
    value: string | number;
    disabled?: boolean;
};
